<template>
  <button @click="$router.go(-1)" class="link-back no-print">&larr; Back</button>
  <h2>Schedule for Week: {{ week.label }}</h2>
  <p>Gate: {{ gate }}</p>
  <div class="entry-table">
    <div v-for="entry in week.entries" :key="entry.name" class="entry-row">
      <div class="name">{{ entry.name }}</div>
      <div class="cell">{{ entry.start }}</div>
      <div class="cell">{{ entry.end }}</div>
    </div>
  </div> 
</template>

<script>
export default {
  inject: ['gateData'],
  data() {
    return {
      week: {},
      gate: null
    }
  },
  methods: {
    
  },
  created() {
    const theWeek = this.$route.params.weekID;
    const theWeekSplit = theWeek.split('-');
    const theGateNumber = Number(theWeekSplit[0])
    const theGate = this.gateData.find((gate) => gate.gate === theGateNumber); 
    const singleData = theGate.gateCalendar.find((week) => week.id === theWeek);  

    this.gate = theGateNumber;
    this.week = singleData;
  }
}
</script>

<style scoped>
.entry-table {
  width: 100%;
  border: 0;
  border-collapse: collapse;
  margin-top: 40px;
}

.entry-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  width: 100%;
}

.name {
  width: 100%;
  border: 0;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 5px;
}

.entry-row .cell {
  border: 1px solid #ccc;
  margin: 0;
  padding: 7px;
  text-align: center;
  flex: 1 1 50%;
}
</style>